import React from 'react';
import { Platform, StyleSheet, ViewStyle } from 'react-native';

import type { UseSound } from '../../../hooks/use-sound';
import { IconAudioPlayer } from '../../icon-audio-player/icon-audio-player';
import { ThemedView } from '../../themed-view';
import {
  centeredRowBox,
  extraSmallPaddingVerticalBox,
  mediumPaddingHorizontalBox,
} from '../../view-style';

interface TitleAudioPlayerProps {
  active: boolean;
  title: string;
  onReproduce?: () => void;
  style?: ViewStyle;
  sound: UseSound;
}

const TitleAudioPlayer: React.FC<TitleAudioPlayerProps> = ({
  active,
  title,
  onReproduce,
  style,
  sound,
}) => {
  return (
    <ThemedView style={[styles.titleContainer, style]}>
      <IconAudioPlayer
        active={active}
        text={title}
        sound={sound}
        onReproduce={onReproduce}
        fontSize={Platform.OS === 'web' ? 'small' : 'medium'}
      />
    </ThemedView>
  );
};

export default TitleAudioPlayer;

const styles = StyleSheet.create({
  titleContainer: {
    display: 'flex',
    ...centeredRowBox,
    ...extraSmallPaddingVerticalBox,
    ...mediumPaddingHorizontalBox,
  },
});
